import { makeStyles, useTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
  },
  clickArea: {
    display: "flex",
  },
  content: {
    flex: 1,
  },
  cover: {
    maxHeight: 100,
    height: "80%",
    width: "30%",
    marginRight: "3%",
  },
  description: {
    minHeight: 40,
    paddingBottom: "5px",
  },
}));

function CustomCard({ name, description, nr, count, img, station, navigate, verifiedString }) {
  const classes = useStyles();
  const theme = useTheme();

  const cardStyles = () => {
    if (station) {
      return { margin: theme.spacing(2) };
    }
    return { margin: theme.spacing(1, 0) };
  };

  return (
    <Card
      elevation={5}
      style={cardStyles()}
      className={classes.root}
      onClick={() => {
        // if we are on "/stationen" wie route to station-detail page, otherwise to the Exercise-detail page
        station ? navigate(`${nr}`) : navigate(`${name.toLowerCase()}${verifiedString}`);
      }}
    >
      <CardActionArea className={classes.clickArea}>
        <CardContent className={classes.content}>
          <Typography component="h5" variant="h6">
            {station ? `${nr}. ${name}` : name}
          </Typography>
          <Typography className={classes.description} variant="subtitle2" color="textSecondary">
            {description}
          </Typography>
          {station && (
            <Typography variant="caption" color="textSecondary">
              {`${count} Übung${count > 1 ? "en" : ""}`}
            </Typography>
          )}
        </CardContent>
        <CardMedia component="img" className={classes.cover} image={img} title="Bild von Station" />
      </CardActionArea>
    </Card>
  );
}

export default CustomCard;
